export const normalizeHydratedPageFile = (baseFile = null, resolvedFile = null) => {
  if (!baseFile && !resolvedFile) {
    return null;
  }

  const base = baseFile || {};
  const resolved = resolvedFile || {};

  const previewUrl = resolved.preview_url
    || resolved.previewUrl
    || resolved.urls?.preview
    || base.preview_url
    || base.previewUrl
    || base.urls?.preview
    || null;

  const thumbnailUrl = resolved.thumbnail_url
    || resolved.thumbnailUrl
    || resolved.urls?.thumbnail
    || base.thumbnail_url
    || base.thumbnailUrl
    || base.urls?.thumbnail
    || null;

  const url = resolved.url || base.url || null;
  const originalName = resolved.original_name
    || resolved.originalName
    || base.original_name
    || base.originalName
    || null;

  return {
    ...base,
    ...resolved,
    previewUrl,
    thumbnailUrl,
    url,
    originalName,
    urls: {
      ...(base.urls || {}),
      ...(resolved.urls || {}),
      preview: resolved.urls?.preview || previewUrl,
      thumbnail: resolved.urls?.thumbnail || thumbnailUrl,
    },
  };
};
